<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 text-sm-right">
                        <button *hasPermission="{app: constant.UMBRALES, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success
                            waves-effect" (click)="openModal()"><i
                                class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                    </div>
                </div>
            </div>

            <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"  class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Umbral</th>
                            <th>Descripción</th>
                            <th>Límite superior</th>
                            <th>Límite inferior</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of dataApp; let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{row.nombre}}</td>
                            <td>{{row.descripcion}}</td>
                            <td>{{row.limiteSuperior}}</td>
                            <td>{{row.limiteInferior}}</td>
                            <td>{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>
                            <td class="text-center">
                                <div class="row">
                                <button *hasPermission="{app: constant.UMBRALES, permission: [constant.ACTUALIZAR]}"  type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="edit(row)">
                                    <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>
                                <button *hasPermission="{app: constant.UMBRALES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro" (click)="delete(row.idSprUmbral)">
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                            </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-umbrales" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>


<jw-modal id="{{nameModal}}">
    <!-- MODAL PARA CREAR Y EDITAR -->

    <div class="modal-dialog" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="modal.close();" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <form action="#" [formGroup]="formUmbrales" class="needs-validation">

                    <div class="row">
                        <input type="hidden" id="idSprUmbral" formControlName="idSprUmbral">
                        <div class="form-floating mb-3">
                            <input type="text" maxlength="50" style="text-transform:uppercase;" id="nombre" class="form-control" formControlName="nombre" required autofocus placeholder="Nombre" [ngClass]="{'ng-invalid ng-dirty' : submitted && UmbralesForm['nombre'].errors}">
                            <small class="invalid-feedback" *ngIf="submitted && UmbralesForm['nombre'].errors">Campo requerido</small>
                            <label for="nombre">Nombre</label>
                        </div>

                        <div class="form-floating mb-3">
                            <textarea maxlength="50" type="text" id="descripcion" class="form-control" oninput="this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1).toLowerCase();" formControlName="descripcion" autofocus placeholder="descripcion" [ngClass]="{'ng-invalid ng-dirty' : submitted && UmbralesForm['descripcion'].errors}"></textarea>
                            <label for="descripcion">Descripción</label>
                        </div>

                        <div class="form-floating mb-3">
                            <input type="number" min="0" max="200" maxlength="3" onkeydown="return false" name="limiteSuperior" id="limiteSuperior" placeholder="Solo caracteres
                                Numericos" class="form-control" required autocomplete="off" onkeypress="return (event.charCode>= 48 && event.charCode <= 57)" formControlName="limiteSuperior" required autofocus placeholder="limiteSuperior" [ngClass]="{'ng-invalid ng-dirty' : submitted && UmbralesForm['limiteSuperior'].errors}">
                                <small class="invalid-feedback" *ngIf="submitted && UmbralesForm['limiteSuperior'].errors">Campo requerido</small>
                                <label for="limiteSuperior">Límite superior
                                </label>
                            </div>
                            <div class="form-floating mb-3">
                                <input type="number" min="0" max="100" maxlength="3" onkeydown="return false" name="limiteInferior" id="limiteInferior" placeholder="Solo caracteres Numericos" class="form-control" required autocomplete="off" onkeypress="return (event.charCode>= 48 && event.charCode <= 57)" formControlName="limiteInferior" required autofocus placeholder="limiteInferior" [ngClass]="{'ng-invalid ng-dirty' : submitted && UmbralesForm['limiteInferior'].errors}">
                                    <small class="invalid-feedback" *ngIf="submitted && UmbralesForm['limiteInferior'].errors">Campo requerido</small>
                                    <label for="limiteInferior">Límite inferior </label>
                                </div>


            <div class="form-floating mb-3">
                <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{
                    'is-invalid': this.formUmbrales.get('estado')?.errors && this.submitted,
                    'is-valid': !this.formUmbrales.get('estado')?.errors,
                  }">
                    <option value="1" selected>Activo</option>
                    <option value="2">Inactivo</option>
                  </select>
                  <label for="estado">Estado</label>
                  <small class="invalid-feedback"
                    *ngIf="this.formUmbrales.get('estado')?.errors?.['required'] && this.submitted"> Campo
                    requerido</small>
                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary waves-effect" (click)="modal.close();">Cerrar</button>
                        <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
                    </div>
                </div>
            </div>
        </jw-modal>
